import { isString } from '@gov-nx/core/types';
import { toDateReadable, today, toTimeReadable } from './utils';

const toDateAndTime = (date: Date) =>
	[toDateReadable(date), toTimeReadable(date)].join(' ');

/**
 * Converts a `Date` (or string parsed via `today`) into `DD.MM.YYYY HH:MM`.
 * The string branch reuses `today` to ensure Prague time zone normalization.
 */
export const toDateTimeReadable = (date: Date | string) => {
	if (isString(date)) {
		return toDateAndTime(today(date));
	}

	return toDateAndTime(date);
};
